module.exports = __webpack_public_path__ + "img/CR.9e60ee5b.svg";